import { Tracker } from 'services/tracking';
import { getHostedPageFlowType } from 'utilities/global';
import { GA_ACTIONS, GA_CATEGORIES, GA_LABEL } from 'consts';

export const trackPageLoad = ({
  gaAction = GA_CATEGORIES.PAGE_LOAD,
  gaCategory = GA_CATEGORIES.PAGE_LOAD
} = {}) => {
  const tracker = new Tracker(getHostedPageFlowType());
  tracker.fireEvent({
    category: gaCategory,
    action: gaAction
  });
};

export const trackThankYouPageLoad = () => {
  const tracker = new Tracker(getHostedPageFlowType());
  tracker.fireEvent({
    category: GA_ACTIONS.PAGE_LOAD_THANK_YOU,
    action: GA_ACTIONS.PAGE_LOAD_THANK_YOU
  });
};

export const trackClickBack = () => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    action: GA_CATEGORIES.BACK_TO_WEBSITE,
    category: GA_CATEGORIES.BACK_TO_WEBSITE
  });
};

export const trackLangPicker = () => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    action: GA_ACTIONS.LANG_PICKER,
    category: GA_ACTIONS.LANG_PICKER
  });
};

export const trackCustomerSupportClick =
  (category = '') =>
  params => {
    const tracker = new Tracker(getHostedPageFlowType());
    const { label = '' } = params || {};

    tracker.fireEvent({
      category,
      action: 'CustomerSupportClick',
      label
    });
  };

export const trackDeleteCard = () => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    action: GA_ACTIONS.DELETE_CARD
  });
};

export const trackLinkClick = (linkType = '') => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: linkType,
    action: GA_ACTIONS.T_AND_C
  });
};

export const trackApplePayClickButton = () => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: GA_ACTIONS.APPLE_PAY,
    action: GA_ACTIONS.APPLE_PAY
  });
};

export const trackGooglePayClickButton = () => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: GA_ACTIONS.GOOGLE_PAY,
    action: GA_ACTIONS.GOOGLE_PAY
  });
};

export const trackDropdownSelect = (selectedValue = '', gaAction) => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: selectedValue,
    action: gaAction
  });
};

export const trackCheckBoxInChange = (checked, gaAction = GA_ACTIONS.SELECT) => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: JSON.stringify({
      [GA_CATEGORIES.CHECKED]: checked
    }),
    action: gaAction
  });
};

export const trackExpandedContentLoad = gaCategory => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: gaCategory,
    action: GA_ACTIONS.EXPANDED_CONTENT_PAGE_LOAD
  });
};

export const trackExpandedContentClose = gaCategory => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: gaCategory,
    action: GA_ACTIONS.EXPANDED_CONTENT_CLOSE
  });
};

export const trackEditSavedCard = gaCategory => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: gaCategory,
    action: GA_ACTIONS.EDIT_SAVED_CARD
  });
};

export const trackCardAbstraction = status => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: status,
    action: GA_ACTIONS.CARD_ABSTRACTION
  });
};

export const trackBillingAddressFieldsLoad = () => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: GA_ACTIONS.BILLING_ADDRESS_FIELDS_LOAD,
    action: GA_ACTIONS.BILLING_ADDRESS_FIELDS_LOAD
  });
};

export const trackCategoryChange = category => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: JSON.stringify({ [GA_LABEL.CATEGORY_CHANGED]: category }),
    action: GA_CATEGORIES.PAYMENT_METHOD_CATEGORY
  });
};

export const trackAction = (actionName, actionStatus) => {
  const tracker = new Tracker(getHostedPageFlowType());
  if (!actionName) return;

  tracker.fireEvent({
    category: actionStatus || actionName,
    action: actionName
  });
};
